import { MapPin, Mail, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-white border-t border-[#CBA153]/40 py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <h3 className="font-serif-luxury text-3xl md:text-4xl text-[#0F4C3A] tracking-tight leading-none">
              The Gower
              <span className="italic text-gold-metallic"> Golf Club</span>
            </h3>
            <p className="text-sm text-[#4A4A4A] mt-4 max-w-md leading-relaxed">
              Golf &amp; Hospitality on the Gower Peninsula. Swansea's welcoming
              wedding, golf, and stay venue — proudly hosting members and guests across South Wales.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="section-eyebrow mb-4">Visit</p>
            <a
              data-testid="footer-address"
              href="https://maps.google.com/?q=Cefn+Goleu+Farm+Gowerton+Swansea+SA4+3HS"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-[#1A1A1A] hover:text-[#CBA153] flex items-start gap-2 leading-relaxed"
            >
              <MapPin size={15} strokeWidth={1.5} className="text-[#CBA153] mt-1 shrink-0" />
              Cefn Goleu Farm, Gowerton,<br />Swansea SA4 3HS
            </a>
          </div>

          <div className="md:col-span-4">
            <p className="section-eyebrow mb-4">Contact</p>
            <a
              data-testid="footer-email"
              href="mailto:info@gowergolf.com"
              className="text-sm text-[#1A1A1A] hover:text-[#CBA153] flex items-center gap-2 mb-2.5"
            >
              <Mail size={15} strokeWidth={1.5} className="text-[#CBA153]" />
              info@gowergolf.com
            </a>
            <a
              data-testid="footer-phone"
              href="tel:+441792872480"
              className="text-sm text-[#1A1A1A] hover:text-[#CBA153] flex items-center gap-2"
            >
              <Phone size={15} strokeWidth={1.5} className="text-[#CBA153]" />
              01792 872480
            </a>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-[#CBA153]/25 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <p className="text-xs text-[#4A4A4A] tracking-wider">
            © {new Date().getFullYear()} The Gower Golf Club · Swansea, South Wales. All rights reserved.
          </p>
          <p className="text-[10px] tracking-[0.3em] uppercase text-gold-metallic">
            Golf on the Gower Peninsula
          </p>
        </div>
      </div>
    </footer>
  );
}
